// @ts-check

/** @file Reorders TaskBoard frontend models through the backend command. */

import {TaskBoard} from "../../frontend-models/task-board.js"

/**
 * @typedef {object} TaskBoardReorderTarget
 * @property {string} boardColumnId Target board-column id.
 * @property {string} id Task-board id.
 * @property {number} rowNumber Target one-based row number.
 * @property {string} taskId Task id for the board placement.
 */

/**
 * Moves one task board through the backend collection command.
 * @param {TaskBoardReorderTarget} target Final task-board position.
 * @returns {Promise<TaskBoard>} Updated task board.
 * @rejects {Error} When the backend command rejects.
 */
export default async function reorderTaskBoards(target) {
  const response = await TaskBoard.reorder({
    boardColumnId: target.boardColumnId,
    id: target.id,
    rowNumber: target.rowNumber,
    taskId: target.taskId
  })
  return response.taskBoard
}
